import React, { useState } from "react";
import "./DesignerOrderPanel.css";

const DesignerOrderPanel = ({
  selectedObject,
  selectedObjects = [],
  selectedObjectIds = [],
  isMultiSelected = false,
  onBringForward,
  onSendBackward,
  onBringToFront,
  onSendToBack,
  onBringForwardOverlap,
  onSendBackwardOverlap,
  onDeleteSelected,
  onCreateGroup,
  onUngroupSelected,
}) => {
  const [collapsed, setCollapsed] = useState(false);

  const hasSelection = selectedObjectIds.length > 0;
  const singleSelection = selectedObjectIds.length === 1;
  const multiSelection = selectedObjectIds.length > 1;

  if (collapsed) {
    return (
      <div className="dop-collapsed-wrap">
        <button
          type="button"
          className="dop-collapse-btn dop-collapse-btn--collapsed"
          onClick={() => setCollapsed(false)}
        >
          Object Order
        </button>
      </div>
    );
  }

  return (
    <div className="dop-panel">
      <div className="dop-header">
        <h3 className="dop-title">Object Order</h3>

        <button
          type="button"
          className="dop-collapse-btn"
          onClick={() => setCollapsed(true)}
          title="Collapse Object Order"
        >
          −
        </button>
      </div>

      <div className="dop-group">
        <div className="dop-group-title">Global</div>

        <div className="dop-buttons">
          <button
            type="button"
            disabled={!singleSelection}
            onClick={onBringForward}
            className="dop-btn"
          >
            Forward
          </button>

          <button
            type="button"
            disabled={!singleSelection}
            onClick={onSendBackward}
            className="dop-btn"
          >
            Backward
          </button>

          <button
            type="button"
            disabled={!singleSelection}
            onClick={onBringToFront}
            className="dop-btn"
          >
            Front
          </button>

          <button
            type="button"
            disabled={!singleSelection}
            onClick={onSendToBack}
            className="dop-btn"
          >
            Back
          </button>
        </div>
      </div>

      <div className="dop-group">
        <div className="dop-group-title">Overlap</div>

        <div className="dop-buttons">
          <button
            type="button"
            disabled={!singleSelection}
            onClick={onBringForwardOverlap}
            className="dop-btn"
          >
            Up Overlap
          </button>

          <button
            type="button"
            disabled={!singleSelection}
            onClick={onSendBackwardOverlap}
            className="dop-btn"
          >
            Down Overlap
          </button>
        </div>
      </div>

      <div className="dop-group">
        <div className="dop-group-title">Grouping</div>

        <div className="dop-buttons">
          <button
            type="button"
            disabled={!multiSelection}
            onClick={onCreateGroup}
            className="dop-btn"
          >
            Create Group
          </button>

          <button
            type="button"
            disabled={!hasSelection}
            onClick={onUngroupSelected}
            className="dop-btn"
          >
            Ungroup
          </button>
        </div>
      </div>

      <div className="dop-group">
        <div className="dop-group-title">Selected</div>

        <div className="dop-buttons">
          <button
            type="button"
            disabled={!hasSelection}
            onClick={onDeleteSelected}
            className="dop-btn dop-btn--danger"
          >
            Delete
          </button>
        </div>
      </div>

      <div className="dop-status">
        {!hasSelection && "No selection"}

        {singleSelection && selectedObject && (
          <>
            <strong>{selectedObject.name}</strong> | z:{" "}
            <strong>{selectedObject.z_index ?? 0}</strong>
            {selectedObject.group ? (
              <>
                {" "}
                | group: <strong>{selectedObject.group}</strong>
              </>
            ) : null}
          </>
        )}

        {multiSelection && (
          <>
            <strong>{selectedObjectIds.length}</strong> objects selected
            {selectedObjects.some((obj) => obj.group) ? (
              <> | some grouped</>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

export default DesignerOrderPanel;